// Lightweight wrapper around the generated @hey-api/client-fetch client.
// Configures the base URL + Authorization bearer header from a token getter.
import { client } from '../generated/services.gen';
let currentTokenGetter;
/**
 * Initialise the shared SDK client. Call once near application startup
 * (e.g. in main.tsx) before any service method is invoked.
 */
export function configureClient(opts) {
    currentTokenGetter = opts.getToken;
    client.setConfig({
        baseUrl: opts.baseUrl,
        headers: {
            'content-type': 'application/json',
        },
    });
    // Inject Authorization header from the token getter on every request.
    client.interceptors.request.use((request) => {
        const token = currentTokenGetter?.();
        if (token) {
            request.headers.set('Authorization', `Bearer ${token}`);
        }
        return request;
    });
}
export { client };
//# sourceMappingURL=index.js.map